import { doc, getDoc, getFirestore } from "firebase/firestore";
import { useQuery, useQueryClient } from "react-query";
import { convertLessonAnswerSnapToILessonAnswer } from "../../types/firestoreMappings";
import { collectionPaths } from "../collectionPaths";
import { settledLogger } from "../settledLogger";

export const getLessonAsnwerQueryKey = (lessonAnswerId: string) => [
  "getLessonAsnwerQueryKey",
  lessonAnswerId,
];

interface IGetLessonAnswerArgs {
  lessonAnswerId: string;
}

const getLessonAnswer = async (vars: IGetLessonAnswerArgs) => {
  const { lessonAnswerId } = vars;
  const db = getFirestore();
  const lessonAnswerDocRef = doc(
    db,
    collectionPaths.lessonAnswers,
    lessonAnswerId
  );
  const snapshot = await getDoc(lessonAnswerDocRef);
  if (snapshot.exists()) {
    return convertLessonAnswerSnapToILessonAnswer(
      lessonAnswerId,
      snapshot.data()
    );
  } else {
    return Promise.reject("getLessonAnswer, lessonAnswerId not found");
  }
};

export const useGetLessonAnswerQuery = (
  vars: IGetLessonAnswerArgs,
  enabled: boolean = true
) => {
  const { lessonAnswerId } = vars;
  return useQuery(
    getLessonAsnwerQueryKey(lessonAnswerId),
    () => getLessonAnswer(vars),
    {
      onSettled: settledLogger("useGetLessonAnswerQuery"),
      enabled,
    }
  );
};

export const useGetLessonAnswerFetch = () => {
  const queryClient = useQueryClient();
  return (vars: IGetLessonAnswerArgs) => {
    const { lessonAnswerId } = vars;
    return queryClient.fetchQuery(getLessonAsnwerQueryKey(lessonAnswerId), () =>
      getLessonAnswer(vars)
    );
  };
};
